import { Injector, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { defer, distinctUntilChanged, merge, Observable, of } from 'rxjs';

/**
 * `toObservable` delivers its first value from an effect, i.e. asynchronously. Callers written
 * against `store.select()` expect the current value on subscribe, so it is replayed inline.
 * Needs an injection context, like `toObservable` itself, unless an `injector` is passed.
 */
export function toSyncObservable<T>(source: Signal<T>, injector?: Injector): Observable<T> {
  const changes$ = toObservable(source, { injector });
  return merge(
    defer(() => of(source())),
    changes$,
  ).pipe(distinctUntilChanged());
}
